import React, { useEffect, useMemo, useState } from 'react'
import DataTable from 'react-data-table-component'
import axios from 'axios'
import moment from 'moment'

import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
import ChallengeForm from './ChallengeForm'
import ChallengeActiveLight from './ChallengeActiveLight'
import { useTableStyles } from './tableTheme'
import './challenges.css'

/*
 * ΠΕΡΙΕΧΟΜΕΝΟ — the content list: challenges, plain posts and sponsor items.
 *
 * GET admin/challenges -> the list
 * GET admin/sports     -> the sport filter
 * Both untouched, and so is the list/form switch: showForm(id, bool) still
 * drives it and ChallengeForm keeps exactly the props it had. The flag itself
 * is local useState — the shared one in UserContext left other screens stuck
 * in form mode.
 *
 * The two filter selects stay native <select> elements (the phone picker is
 * the right control); challenges.css strips their platform chrome and gives
 * them the same box and caret as the text input beside them.
 *
 * The grid stays react-data-table-component; it is fed customStyles built from
 * theme/tokens.css (tableTheme.js) so it repaints with the product on a theme
 * change, and it scrolls inside its own container so a wide row never pushes
 * the page sideways.
 */

const IconEdit = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>
  </svg>
)

const IconPlus = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
)

const IconList = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 5.5h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1zm3 3.5h10M7 12h10M7 15h6"/>
  </svg>
)

const typeLabel=(row)=>(row.IsChallenge==1 ? 'CHALLENGE' : row.IsChallenge==2 ? 'SPONSOR' : 'ARTICLE')

const dayText=(value)=>{
  if (!value) return ''
  const parsed=moment(value)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : String(value)
}

export default function Programs() {

    // Local, not context: a shared form flag leaked between screens.

    const [form, setForm] = useState(false)
    const [id,setId]=useState(0)
    const [isLoading,setIsLoading]=useState(true)
    const [failed,setFailed]=useState(false)
    const [data,setData]=useState([])
    const [dataFlt,setDataFlt]=useState([])
    const [flt,setFlt]=useState('')
    const [sportFlt,setSportFlt]=useState('')
    const [typeFlt,setTypeFlt]=useState('')
    const [sports,setSports]=useState([])

    const tableStyles=useTableStyles()

    const columns = [
        {
            name: '#',
            selector: (row,index) =>  index+1,
            sortable: true,
            width:'66px'
        },

        {
            name: '',
            cell: row => (
                <span className="chx-cell-act">
                    <Btn onClick={()=>{showForm(row.UUID,true)}} aria-label={'Edit — '+(row.Title||'')} title="Edit">
                        <IconEdit/>
                    </Btn>
                </span>
            ),
            width:'78px'
        },

        {
            name: 'Active',
            selector: row => {
                let yourDate = new Date()
                const today=yourDate.toISOString().split('T')[0]
                return row.IsChallenge!=1 ? row.IsActive : row.DateTo<today ? 0 : row.IsActive
            },
            cell: row =>  {
                let yourDate = new Date()
                const today=yourDate.toISOString().split('T')[0]
                const isActive=row.IsChallenge!=1 ? row.IsActive : row.DateTo<today ? 0 : row.IsActive
                return(
                    <ChallengeActiveLight isActive={isActive}/>
                )

            },
            sortable: true,
            width:'96px'
        },
        {
            name: 'Content Type',
            selector: row =>  typeLabel(row),
            cell: row => <span className="chx-pill"><i aria-hidden="true"></i>{typeLabel(row)}</span>,
            sortable: true,
            width:'190px'
        },
        {
            name: 'Name',
            selector: row =>  row.Title,
            cell: row => <span className="chx-cell-wrap">{row.Title}</span>,
            sortable: true,
            wrap: true,
            grow: 2,
            minWidth:'220px'
        },
        {
            name: 'Created',
            selector: row =>  row.DateCreated,
            cell: row => <span className="mono">{dayText(row.DateCreated)}</span>,
            sortable: true,
            width:'150px'
        },

        {
            name: 'Ends (challenges only)',
            selector: row =>  row.IsChallenge==1 ? row.DateTo : '',
            cell: row => <span className="mono">{row.IsChallenge==1 ? dayText(row.DateTo) : ''}</span>,
            sortable: true,
            width:'200px'
        },
    ]


    useEffect(()=>{
        setIsLoading(true)
        loadData()
        loadSports()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[form])


    const loadData=()=>{
        setIsLoading(true)
        setFailed(false)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/challenges',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }
          })
        .then(res=>{
        //console.log(res.data.results)
          setData(res.data.results)
          setDataFlt(res.data.results)
          setIsLoading(false)

        }).catch(err=>{
            setIsLoading(false)
            setFailed(true)
            console.log(err)
        })
      }

      const loadSports=()=>{
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/sports',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }
          })
        .then(res=>{
           // console.log(res.data.results)
          setSports(res.data.results)
          setIsLoading(false)

        }).catch(err=>{
            setIsLoading(false)
            console.log(err)
        })
      }

    const showForm=(id,a)=>{
        setForm(a)
        setId(id)
    }

    const sportsList=(Array.isArray(sports) ? sports : []).map(item=>{
        return(
          <option key={item.SportID} value={item.SportID}>{item.SportName}</option>
        )
      })


      const clearCretiria=()=>{
        setFlt('')
        setSportFlt('')
        setTypeFlt('')
        setDataFlt([...data])

      }

    const search=(e)=>{
        e.preventDefault()
        var dataRes=[]
        if (flt.length>0){
            dataRes=[...data].filter(item=>item.Title.toUpperCase().includes(flt.toUpperCase()))
        }else{
            dataRes=[...data]
        }


        if (sportFlt.length>0){
            dataRes=dataRes.filter(item=>item.SportID==sportFlt)
        }

        if (typeFlt.length>0){
            dataRes=dataRes.filter(item=>item.IsChallenge==typeFlt)
        }

       setDataFlt(dataRes)
    }

    const rows=useMemo(()=>(Array.isArray(dataFlt) ? dataFlt : []),[dataFlt])
    const total=Array.isArray(data) ? data.length : 0
    const filtered=flt.length>0 || sportFlt.length>0 || typeFlt.length>0


    /* The form owns its own panels — languages, videos and submissions stack
       below the record — so the list simply steps aside for it. */
    if (form){
      return (
        <ChallengeForm id={id} showForm={showForm} setForm={setForm} loadData={loadData}/>
      )
    }

    return (
        <div className="chx-page">

          <Panel title="Filters and Search" subtitle="Narrow the list before you open it">
            <form className="chx-form" onSubmit={search}>
              <div className="chx-fields">

                <div className="chx-field">
                  <label className="chx-label" htmlFor="chl-title">Title</label>
                  <input
                    id="chl-title"
                    className="chx-input"
                    type="text"
                    value={flt}
                    onChange={(e)=>setFlt(e.target.value)}
                    placeholder="Search by title…"
                  />
                </div>

                <div className="chx-field">
                  <label className="chx-label" htmlFor="chl-type">Post Type</label>
                  <select
                    id="chl-type"
                    className="chx-select"
                    value={typeFlt}
                    onChange={(e)=>setTypeFlt(e.target.value)}
                  >
                    <option value=''>[Select post type]</option>
                    <option value='1'>Challenge</option>
                    <option value='0'>Plain Post</option>
                  </select>
                </div>

                <div className="chx-field">
                  <label className="chx-label" htmlFor="chl-sport">Sport</label>
                  <select
                    id="chl-sport"
                    className="chx-select"
                    value={sportFlt}
                    onChange={(e)=>setSportFlt(e.target.value)}
                  >
                    <option value=''>[Select sport]</option>
                    {sportsList}
                  </select>
                </div>

              </div>

              <div className="chx-actions">
                <Btn onClick={()=>clearCretiria()}>Clear</Btn>
                <Btn type="submit" variant="accent">Search</Btn>
              </div>
            </form>
          </Panel>

          <Panel
            title="List"
            subtitle={isLoading
              ? 'Loading…'
              : rows.length+(filtered ? ' of '+total : '')+' records'}
            actions={<Btn variant="accent" onClick={()=>{showForm(0,true)}}><IconPlus/>Add</Btn>}
          >

            {isLoading && (
              <div className="chx-sk">
                <div className="skeleton chx-sk-line"></div>
                <div className="skeleton chx-sk-line"></div>
                <div className="skeleton chx-sk-line chx-sk-short"></div>
              </div>
            )}

            {!isLoading && failed && (
              <div className="chx-note chx-note-crit" role="alert">
                <span className="chx-note-text">
                  <b>The list could not be loaded.</b> The server did not respond. Please try again.
                </span>
                <Btn onClick={loadData}>Try again</Btn>
              </div>
            )}

            {!isLoading && !failed && rows.length===0 && (
              <div className="chx-empty">
                <span className="chx-empty-mark" aria-hidden="true"><IconList/></span>
                <h2 className="chx-empty-title">
                  {total===0 ? 'No content yet' : 'No results'}
                </h2>
                <p className="chx-empty-text">
                  {total===0
                    ? 'No content has been added yet. Press “Add” to create the first challenge or article.'
                    : 'No results match these filters. Press “Clear” to see the whole list again.'}
                </p>
              </div>
            )}

            {!isLoading && !failed && rows.length>0 && (
              <div className="chx-table">
                <div className="chx-table-inner chx-table-inner-wide">
                  <DataTable
                    columns={columns}
                    data={rows}
                    highlightOnHover
                    customStyles={tableStyles}
                    //expandableRows
                    //expandableRowsComponent={ExpandedComponent}
                    //pagination
                  />
                </div>
              </div>
            )}

          </Panel>

        </div>
    )
}
